import { Pipe, PipeTransform } from '@angular/core';
import {TimeZoneService} from '@core/services/time-zone.service';
import {monthNames} from '../constants/dashboard.constants';

@Pipe({
    standalone: false,
    name: 'taxnewsDateFormat'
})
export class TaxnewsDateFormatPipe implements PipeTransform {

  constructor(private timeZoneService: TimeZoneService) {

  }

  transform (utcDateString: any, ...args: any[]): any {
    const date = this.timeZoneService.getDisplayDate(utcDateString)
    if (date) {
      const day = date.getDate();
      const monthIndex = date.getMonth();
      const year = date.getFullYear();
      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
  }
}
